/***
 * script.js
 *
 * @author  inoue
 * @link	https://code-base.jp
 * @since   2020-08-14
 */

 function pagetop() {
	$(window).scroll(function() {
		if ($(this).scrollTop() > 200) {
			$('.pagetop').fadeIn(200);
		} else {
			$('.pagetop').fadeOut(200);
		}
	});
	// Animate the scroll to top
	$('.pagetop').click(function(event) {
		event.preventDefault();
		$('html, body').animate({scrollTop: 0}, 1000);
	})
}

$(function() {

	pagetop();

	/* Gnavi Scroll */
	var box = $("#js-header-wrapper");
	var flag = false;
	$(window).scroll(function () {
		var stop01 = $("#back");
		var stop02 = $("#close");
		if (!stop01.length && !stop02.length) {
			if($(window).scrollTop() >= 300 && !flag) {
				box.addClass("fixed");
				flag = true;
			} else if ($(window).scrollTop() <= 0 && flag) {
				box.removeClass("fixed");
				flag = false;
			}
		}
	});
	// よく使われるキーワード表示
	$('#search_string')
		.focusin(function(e) {
			$('#keyword').fadeIn('fast');
		})
		.focusout(function(e) {
			$('#keyword').fadeOut('fast');
		});

	/* menu - first view */
	$('.menu').on('click', function(){
		remove_func('menu');
		$('.menu').toggleClass('active');
		if ($('.menu.active').length) {
			$('#menu').fadeIn('fast');
		} else {
			$('#menu').fadeOut('fast');
		}
		$('.menu+.sec').fadeOut('fast').queue(function() {
			this.remove();
		});
	});
	/* menu - sec view */
	$('#menu > li > a').on('click', function(){
		$('#menu').fadeToggle('fast');
		var cl = $(this).attr('class');
		var $submenu = $('ul.'+cl);
		$in = $submenu.clone().attr('id', 'back').insertAfter($('#menu'));
		$('#back').prepend('<li><a href="#" class="back">戻る</a></li>');
	});
	/* back */
	$('body').on('click', 'a.back', function(){
		$(this).closest('ul').fadeOut('fast').queue(function(){
			this.remove();
		});
		$('#menu').fadeToggle('fast');
	});
	/* close */
	$('body').on('click', 'a.close', function(){
		$('#submenu li').find('a').removeClass('select');
		$(this).closest('ul').fadeOut('fast').queue(function(){
			this.remove();
		});
	});
	/* kaihei */
	$('body').on('click', '.kaihei', function(){
		if ($(window).width() >= 768) return;
		$(this).nextAll('ul').slideToggle('300', function() {
			$(this).prev('a').toggleClass('active');
		});
		$('.kaihei.active').not($(this)).nextAll('ul').slideToggle('300', function() {
			$(this).prev('a').toggleClass('active');
		});
	});
	/* submenu click */
	$('#submenu a').on('click', function(){
		if ($(this).hasClass('select')) { /* close */
			if ($(this).hasClass('guide')) {
				$(this).removeClass('select');
				if ($('#guide_box').length) $('#guide_box').fadeOut('fast');
			} else {
				$(this).removeClass('select');
				if ($('#close').length) {
					$('#close').fadeOut('fast').queue(function(){
						this.remove();
					});
				}
			}
		} else { /* open */
			remove_func('guide');
			$('#submenu li').find('a').removeClass('select');
			var cl = $(this).attr('class');
			$(this).addClass('select');
			if ($('#close').length) $('#close').remove();
			if (cl == 'guide') {
				$('#guide_box').fadeIn('fast');
			} else {
				var $submenu = $('ul.'+cl);
				$submenu.clone().attr('id', 'close').insertAfter($('#submenu'));
				if ($(window).width() < 768) $('#close').prepend('<li><a href="#" class="close">閉じる</a></li>');
			}
		}
	});
	$('.cart_button a').on('click', function(){
		var isLoginOpen = $('.login_open').length;

		if( isLoginOpen > 0) {
			$('#cart_login').removeClass('login_open');
			$('#cart_login').addClass('login_close');
			$('#recover_cart_password').removeClass('recovery_close');
			$('#recover_cart_password').addClass('recovery_open');
			$('.cart_recovery').css('display','none');
			$('.cart_login').css('display','block');
		} else {
			$('#recover_cart_password').removeClass('recovery_open');
			$('#recover_cart_password').addClass('recovery_close');
			$('#cart_login').removeClass('login_close');
			$('#cart_login').addClass('login_open');
			$('.cart_login').css('display','none');
			$('.cart_recovery').css('display','block');
		}


	});
	$('.search_close').on('click', function(){
		$('#search_box').fadeOut('fast');
		$('#keyword').fadeOut('fast');
	});
	/* user_view click */
	$('.user_view').on('click', function(){
		var width = $(window).width();
		var element = document.getElementById('account-popover');

		if(width >= 768){
		  remove_func('user_view');
		  if ($(this).hasClass('active')) {
		  	$(this).removeClass('active');
			element.setAttribute('aria-hidden', 'true');
		  } else {
		  	$(this).addClass('active');
		  	element.setAttribute('aria-hidden', 'false');
		  }
		}
	});
	/* keyword select */
	$('#keyword ul li').on('click', function(){
		$('#search_string').val(($(this).text()));
	});
	/* remove_func */
	function remove_func(type) {
		if (type == 'all') {
			$('#submenu li').find('a').removeClass('select');
			$('.icons div').find('a').removeClass('active');
			if ($('.menu.active').length) {
				$('#menu').fadeOut('fast');
				$('.menu').toggleClass('active');
			}
			if ($('#close').length) $('#close').remove();
			if ($('#back').length) $('#back').remove();
			if ($('.user_view.active').length) {
				$('.user_box').fadeOut('fast');
				$('.user_view').removeClass('active');
			}
			$('#guide_box').fadeOut(0);
		}
		if (type == 'menu') {
			$('#submenu li').find('a').removeClass('select');
			$('.icons div').find('a').removeClass('active');
			if ($('#close').length) $('#close').remove();
			if ($('#back').length) $('#back').remove();
			if ($('.user_view.active').length) {
				$('.user_box').fadeOut('fast');
				$('.user_view').removeClass('active');
			}
			$('#guide_box').fadeOut(0);
		}
		if (type == 'user_view') {
			$('#submenu li').find('a').removeClass('select');
			if ($('.menu.active').length) {
				$('#menu').fadeOut('fast');
				$('.menu').toggleClass('active');
			}
			if ($('#close').length) $('#close').remove();
			if ($('#back').length) $('#back').remove();
			$('#guide_box').fadeOut(0);
		}
		if (type == 'guide') {
			$('#submenu li').find('a').removeClass('select');
			if ($('.menu.active').length) {
				$('#menu').fadeOut('fast');
				$('.menu').toggleClass('active');
			}
			if ($('#close').length) $('#close').remove();
			if ($('#back').length) $('#back').remove();
			if ($('.user_view.active').length) {
				$('.user_box').fadeOut('fast');
				$('.user_view').removeClass('active');
			}
			$('#guide_box').fadeOut(0);
		}
	}
	/* メインスライダー */
	var $slider = $('.slider');
	var width = $(window).width();

	if(width <= 767){
		$slider.slick({
			autoplay: true,
			dots: false,
			arrows: true,
			centerMode: true,
			centerPadding: '10%',
			prevArrow: '<button class="slide-arrow prev-arrow"></button>',
			nextArrow: '<button class="slide-arrow next-arrow"></button>'
		});
	} else {
		$slider.slick({
			autoplay: true,
			slidesToShow: 3,
			dots: false,
			arrows: true,
			prevArrow: '<button class="slide-arrow prev-arrow"></button>',
			nextArrow: '<button class="slide-arrow next-arrow"></button>'
		});
	}

	/* カテゴリーランキング slider */
	$('.cat_ranking ul').slick({
		autoplay: false,
		infinite: false,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 4,
		focusOnSelect: true,
		cssEase: 'cubic-bezier(.64,.65,.37,.96)',
		prevArrow: '<div class="slide-arrow prev-arrow"></div>',
		nextArrow: '<div class="slide-arrow next-arrow"></div>',
		responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
			}
		},
		{
			breakpoint: 580,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
			}
		}]
	});
	/* カテゴリーインデックス slider */
	$('.cat_index ul').slick({
		autoplay: false,
		infinite: false,
		speed: 500,
		slidesToShow: 7,
		slidesToScroll: 7,
		focusOnSelect: true,
		cssEase: 'cubic-bezier(.64,.65,.37,.96)',
		prevArrow: '<div class="slide-arrow prev-arrow"></div>',
		nextArrow: '<div class="slide-arrow next-arrow"></div>',
		responsive: [
		{
			breakpoint: 1000,
			settings: {
				slidesToShow: 5,
				slidesToScroll: 5,
			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 4,
				slidesToScroll: 4,
			}
		},
		{
			breakpoint: 580,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
			}
		}]
	});
	/* フォトログ */
	$('.photolog ul').slick({
		autoplay: true,
		infinite: true,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 4,
		autoplaySpeed: 5000,
		cssEase: 'cubic-bezier(.64,.65,.37,.96)',
		prevArrow: '<img src="./images/photolog/slick-hm-prev.png" class="slide-arrow prev-arrow">',
		nextArrow: '<img src="./images/photolog/slick-hm-next.png" class="slide-arrow next-arrow">',
		responsive: [{
			breakpoint: 700,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
			}
		}]
	});
	/* あなたへのおすすめ商品 slider */
	$('.your-pickup ul').slick({
		autoplay: false,
		infinite: false,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 4,
		focusOnSelect: true,
		cssEase: 'cubic-bezier(.64,.65,.37,.96)',
		prevArrow: '<div class="slide-arrow prev-arrow"></div>',
		nextArrow: '<div class="slide-arrow next-arrow"></div>',
		responsive: [
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 3,
			}
		},
		{
			breakpoint: 580,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
			}
		}]
	});
		$('.category-slider').slick({
			autoplay:true,
			speed:500,
			autoplaySpeed:3500,
			arrows:true,
			dots:true,
			slidesToShow: 1,
			variableWidth: true,
			centerMode: true,
			centerPadding: "0",
			cssEase: 'cubic-bezier(.64,.65,.37,.96)',
			prevArrow: '<button class="slide-arrow prev-arrow"></button>',
			nextArrow: '<button class="slide-arrow next-arrow"></button>'
		});
	/* ページ内リンク スクロール */
	$('a[href*="#"]').click(function(event) {
		currentUrl = location.href;
		currentUrl = currentUrl.split("#")[0];
		var href = $(this).prop("href")
		var hrefSplit = href.split("#");
		var hrefFirst = hrefSplit[0];
		var href = '#' + hrefSplit[1];
		var plus = 0;
		/*
		if (currentUrl == hrefFirst) {
			var target = $(href);
			var position = target.offset().top - plus;
			$('body,html').stop().animate({scrollTop:position}, 1500, 'easeInOutExpo', function(){
				$("#header").removeClass("fixed");
			});
			event.preventDefault();
		}*/
	});
	/* 開閉 a.plus, h2.plus */
	$('a.plus, h2.plus').on('click', function(){
		if ($(this).hasClass('open')) {
			$(this).removeClass('open');
			$(this).nextAll('ul').slideUp('fast');
		} else {
			$(this).addClass('open');
			$(this).nextAll('ul').slideDown(600);
		}
	});
	/* 開閉 span.plus */
	$('span.plus').on('click', function(){
		if ($(this).hasClass('close')) {
			$(this).removeClass('close');
			$(this).parent().next('.wrap').slideDown('fast');
		} else {
			$(this).addClass('close');
			$(this).parent().next('.wrap').slideUp('fast');
		}
	});
	/* 開閉 Cart 送料の確認 */
	$('h3.plus').on('click', function(){
		if ($(this).hasClass('close')) {
			$(this).removeClass('close');
			$(this).next('.wrap').slideUp('fast');
		} else {
			$(this).addClass('close');
			$(this).next('.wrap').slideDown('fast');
		}
	});
	/* 開閉 Cart 注文詳細 */
	$('span.detail_view').on('click', function(){
		if ($(this).hasClass('close')) {
			$(this).removeClass('close');
			$(this).parent().next('.wrap').slideUp('fast');
		} else {
			$(this).addClass('close');
			$(this).parent().next('.wrap').slideDown('fast');
		}
	});
	/* 開閉 Cart 配送方法の選択 */
	$('.border_box2 input[type=radio]').on('change', function(){
		$(this).closest('.border_box2').find('dd').slideUp('fast');
		$(this).closest('dl').find('dd').slideDown('fast');
		$(this).closest('.border_box2').find('dl').removeClass('select');
		$(this).closest('dl').addClass('select');
	});

	/* 機種を選択 */
	$('fieldset.model input').on('click', function(){
		fieldset_model();
	});
	$(window).load(function(){
		fieldset_model();
	});
	function fieldset_model() {
		$('fieldset.model input').each(function(){
			if ($(this).prop('checked')) {
				$('fieldset.model .model_txt').text($(this).val());
			}
		});
	}
	/* カラーを選択 */
	$('fieldset.color input').on('click', function(){
		fieldset_color();
	});
	$(window).load(function(){
		fieldset_color();
	});
	function fieldset_color() {
		$('fieldset.color input').each(function(){
			if ($(this).prop('checked')) {
				$('fieldset.color .color_txt').text($(this).val());
			}
		});
	}
	/* 表示切替 */
	$('.view_change_mode button').on('click', function(){
		if ($(this).hasClass('block') && !$(this).hasClass('active')) {
			$('button.line').removeClass('active');
			$(this).addClass('active');
			$('ul.blockline').addClass('block');
			$('ul.blockline').removeClass('line');
		} else if ($(this).hasClass('line') && !$(this).hasClass('active')) {
			$('button.block').removeClass('active');
			$(this).addClass('active');
			$('ul.blockline').addClass('line');
			$('ul.blockline').removeClass('block');
		}
	});
	/* カートの商品別個数 */
	$('button.btn-minus').click(function(event){
		event.preventDefault();
		fieldName = $(this).attr('data-field');
		var input = $("input[name='"+fieldName+"']");
		var currentVal = parseInt(input.val());
		if (!isNaN(currentVal)) {
			input.val(currentVal-1).change();
			if ((currentVal-1)==1) $(this).attr('disabled', true);
		}
	});
	$('button.btn-plus').click(function(event){
		event.preventDefault();
		fieldName = $(this).attr('data-field');
		var input = $("input[name='"+fieldName+"']");
		var currentVal = parseInt(input.val());
		if (!isNaN(currentVal)) {
			input.val(currentVal+1).change();
			$(this).parent().find('button.btn-minus').attr('disabled', false);
		}
	});
	$(window).on('resize load',function(event){
		var w = $(window).innerWidth();
		if (w < 768) {
			/* トップ おすすめ商品 slider */
			$('.slider-view').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				fade: true,
				asNavFor: '.slider-nav',
				adaptiveHeight: true,
			});
			/* トップ おすすめ商品 ナビ slider */
			$('.slider-nav').slick({
				infinite: false,
				slidesToShow: 4,
				slidesToScroll: 1,
				asNavFor: '.slider-view',
				dots: true,
				arrows: false,
				focusOnSelect: true,
			});
			/* detail side移動 */
			if (!$('.clone_detail').length) {
				var $side_console = $('#detail .side_console');
				var $side_guide = $('#detail .side_guide');
				var $side_delivery = $('#detail .side_delivery');
				$side_delivery.clone().attr('class', 'side_delivery clone_detail').insertAfter($('.item_view'));
				$side_guide.clone().attr('class', 'side_guide clone_detail').insertAfter($('.item_view'));
				$side_console.clone().attr('class', 'side_console clone_detail').insertAfter($('.item_view'));
			}
			/* clone nav delete */
			$('ul.clone-nav').remove();
			if (w < 580) {
				$('ul.items2').removeClass('line');
				$('button.block').addClass('active');
				$('button.line').removeClass('active');
			}
		} else {
			try {
				$('.slider-view').slick('unslick');
				$('.slider-nav').slick('unslick');
			} catch(e) { }
			/* load時の嵌めこみ */
			if (!$('.pc_view').html()) {
				/*$('ul.slider-nav li:nth-child(1)').addClass('active');*/
				$('.pc_view').html('<img src="'+$('ul.slider-nav li img').attr('src')+'" alt="">');
			}
			/* サムネ列の調整 */
			if (!$('ul.clone-nav').length) {
				if ($('ul.slider-nav li').length > 9) {
					var $c1 = "";
					var $c2 = "";
					$('ul.slider-nav li').each(function(index, element){
						if (index < 9) {
							$c1 = $c1 + element.outerHTML;
						} else {
							$c2 = $c2 + element.outerHTML;
						}
					});
					$('<ul class="clone-nav c1">'+$c1+'</ul><ul class="clone-nav c2">'+$c2+'</ul>').insertAfter($('ul.slider-nav'));
				} else {
					var $snav = $('ul.slider-nav');
					$snav.clone().attr('class', 'clone-nav c0').insertAfter($('ul.slider-nav'));
				}
			}
			/* clone_detail delete */
			if ($('.clone_detail').length) $('.clone_detail').remove();
			/* トップ おすすめ商品 左サムネクリック処理 */
			$('ul.clone-nav.c0 li img').on('click', function(){
				var src = $(this).attr('src');
				$(this).closest('ul.clone-nav.c0').find('li').removeClass('active');
				$(this).parent('li').addClass('active');
				$(this).parent().parent().next('.pc_view').hide().html('<img src="'+src+'" alt="">').fadeIn();
			});
			$('ul.clone-nav.c1 li img').on('click', function(){
				var src = $(this).attr('src');
				$('ul.clone-nav.c2').find('li').removeClass('active');
				$(this).closest('ul.clone-nav.c1').find('li').removeClass('active');
				$(this).parent('li').addClass('active');
				$(this).parent().parent().siblings('.pc_view').hide().html('<img src="'+src+'" alt="">').fadeIn();
			});
			$('ul.clone-nav.c2 li img').on('click', function(){
				var src = $(this).attr('src');
				$('ul.clone-nav.c1').find('li').removeClass('active');
				$(this).closest('ul.clone-nav.c2').find('li').removeClass('active');
				$(this).parent('li').addClass('active');
				$(this).parent().parent().siblings('.pc_view').hide().html('<img src="'+src+'" alt="">').fadeIn();
			});
		}
	});

	if ($('#judgeme_product_reviews').length > 0) {
		var target = $('#judgeme_product_reviews')[0];

		var config = {
			attributes: true,
			childList: true,
			characterData: true,
			subtree: true
		};

		var callback = function (mutationsList) {
			for (var mutation of mutationsList) {
				if (mutation.type === 'childList') {
					if (mutation.target.classList.contains('jdgm-rev__timestamp')) {

						var reviewdateObj = $(".jdgm-rev__timestamp");

						reviewdateObj.each(function(index, element){
							var jptimestamp = $(element).data('content');
							var date = new Date(jptimestamp.replace(/-/g,"/"));
							$(element).after(
								'<p class="jp-timestamp">' +
								date.getFullYear() +
								'/' + ('0' + (date.getMonth() + 1)).slice(-2) +
								'/' + ('0' + date.getDate()).slice(-2) +
								'</p>'
							);
						});
					} else if (mutation.target.classList.contains('jdgm-rev-widg__summary-text')) {
						var text = '<span id="extra-text"><br>※当店のレビューは購入されたお客様のみご記載いただけます。<br>' +
'※コメントは公開されます。個人情報等はご記入されないようお願い致します。<br>' +
'※レビューはショップ管理者の確認後に掲載されます。該当商品以外のレビューや、誹謗中傷などは非掲載になる場合があります。</span>'  ;
						var jdgm_text = $('.jdgm-rev-widg__summary-text');
						var extra_text = $('#extra-text');
						if(mutation.addedNodes.length > 0 && extra_text.length == 0) {
							jdgm_text.after(text);
						}
					} else if (mutation.target.classList.contains('jdgm-rev__author')) {
						$('.jdgm-rev__author').remove();
					}
				}
			}
		};

		var observer = new MutationObserver(callback);

		observer.observe(target, config);
	}
	var menuitem_left = $('.before_list--left');

	if ( menuitem_left.length > 0 ) {
		$('.before_list--left').addClass('list--left');
		$('.before_list--left').removeClass('before_list--left');
	}

	if ($('#spiceaddonsappid').length > 0) {
		var target = $('#spiceaddonsappid')[0];

		var config = {
			attributes: true,
			childList: true,
			characterData: true,
			subtree: true
		};

		var classList = ['.spicegems-main-price', '.spicegems-addon-price'];

		var callback = function (mutationsList) {
			for (var mutation of mutationsList) {
				if (mutation.type === 'childList') {

					const number_format = new Intl.NumberFormat();

					$.each(classList, function(index, value){
						$(value).each(function(i, el) {
							var price = $(el).html();
							if (price.indexOf('税抜') == -1 && price.indexOf('Sold Out') == -1) {
								price = price.replace(/(\u005C)|(\u00A5)|,|JPY|円|<span class=\"money\">|<\/span>/g, '');
								var html = '<div class="product-item__price-list price-list">' +
									'<span class="price"><span class="visually-hidden">特価</span>' + number_format.format(Number(price).toFixed()) + '<span class="price_unit">円</span></span>&nbsp;' +
									'<span class="tax-in">(税抜' + number_format.format(Number(price / 1.1).toFixed()) + '円)</span>' +
									'</div>';

								$(el).html(html);
							}
						});
					})
				}
			}
		};

		var observer = new MutationObserver(callback);

		observer.observe(target, config);
	}

	var spicegemsQuickview = function () {
		if ($('#spicegems-product_quickview').length > 0) {
			clearInterval(spicegemsQuickviewObserver);
			starspicegemsQuickview();
			var el = $('#spicegems-product_quickview').find(".spicegems-main-price").html();
			var price = toRawprice(el);
			$('#spicegems-product_quickview').find(".spicegems-main-price").html(modifypriceHtml(price));
		}
	};
	var spicegemsQuickviewObserver = setInterval(spicegemsQuickview, 1000);

	function starspicegemsQuickview() {
		var target = $("#spicegems-product_quickview")[0];
		var config = {
			attributes: true,
			childList: true,
			characterData: true,
			subtree: true
		};
		var callback = function (mutationsList) {
			for (var mutation of mutationsList) {
				var el = $(mutation.target).find(".spicegems-main-price").html();
				if( el !== undefined){
					if (el.indexOf('税抜') == -1) {
						var price = toRawprice(el);
						$(mutation.target).find(".spicegems-main-price").html(modifypriceHtml(price));
					}
				}
			}
		};

		var observer = new MutationObserver(callback);
		observer.observe(target, config);
	};

	if ($('.limespot').length > 0) {
		var limespot_target = $('.limespot')[0];

		var config = {
			attributes: true,
			childList: true,
			characterData: true,
			subtree: true
		};

		var ls_classList = ['.ls-price'];

		var callback = function (mutationsList) {
			for (var mutation of mutationsList) {
				if (mutation.type === 'childList') {

					$.each(ls_classList, function(index, value){
						$(value).each(function(i, el) {
							var ls_price = $(el).html();
							if (ls_price.indexOf('税抜') == -1 && ls_price.indexOf('Sold Out') == -1) {
								ls_price = ls_price.replace(/,/g, '');
								ls_price = ls_price.replace(/(\uffe5)|(\u005C)|(\u00A5)/g,"");

								var html = '<div class="product-item__price-list price-list">' +
									'<span class="price"><span class="visually-hidden">特価</span>' + Number(ls_price) + '<span class="price_unit">円</span></span>&nbsp;' +
									'<span class="tax-in">(税抜' + Number(ls_price / 1.1).toFixed() + '円)</span>' +
									'</div>';

								$(el).html(html);
							}
						});
					})
				}
			}
		};

		var observer = new MutationObserver(callback);

		observer.observe(limespot_target, config);
	}

	const covetpicspopup = function () {
		const cpp = $('covet-pics-popup');
		if (cpp.length > 0 && typeof(cpp[0].shadowRoot) != 'undefined') {
			clearInterval(covetpicspopupObserver);

			const config = {childList: true};
			for( var i=0; i < cpp.length; i++ ) {
				let target = $("covet-pics-popup")[i].shadowRoot.querySelector('.popup-dialog');
				let callback =  function (mutationList) {
					for (var mutation of mutationList) {
						$(mutation.target).find(".product-sale").remove();
						$(mutation.target).find(".product-price").each(function() {
							let str = $(this).html();
							if (str.indexOf('円') == -1) {
								let price = str.replace(/(\u005C)|(\u00A5)|JPY|From|\+s/g, '');
								let exclude_tax = price.replace(/,/g, '');
								exclude_tax = Number(exclude_tax / 1.1).toFixed();
								exclude_tax = Number(exclude_tax).toLocaleString();
								let html = '<span class="price">' + price + '<span class="price_unit">円</span></span>&nbsp;' + '<span class="tax-in">(税抜' + exclude_tax + '円)</span>';

								$(this).html(html);
							}
						});
					}
				}

				let observer = new MutationObserver(callback);
				observer.observe(target, config);
			}
		}
	}
	const covetpicspopupObserver = setInterval(covetpicspopup, 1000);

	// hotfix
	var td = $('td[width="130"]');
	td.attr('width', 300);
	// hotfix

});
